import { Inject, Injectable, Optional } from '@angular/core';

import { SyncUserSettingsService } from '@frontend/sports/user/feature';

import { IBetslipState } from '../../../../../base/store/state';
import { IBetslip } from '../../../../bet-generation/models';
import { BetslipError } from '../../../errors/betslip-error';
import { ErrorTrackingService } from '../../tracking/error-tracking.service';
import { BETSLIP_VALIDATION_COMPOSER_INJECTION_TOKEN, IBetslipValidationComposer } from './betslip-validation-composers';

@Injectable()
export class BetslipValidationComposerService {
    constructor(
        private errorTracking: ErrorTrackingService,
        private userSettings: SyncUserSettingsService,
        @Optional()
        @Inject(BETSLIP_VALIDATION_COMPOSER_INJECTION_TOKEN)
        private betslipValidationComposers?: IBetslipValidationComposer[],
    ) {}

    validateBetslip(betslip: IBetslip, state: IBetslipState): BetslipError[] {
        const betslipErrors =
            this.betslipValidationComposers?.flatMap((v) => Array.from(v.validateBetslip(betslip, state, this.userSettings.earlyPayoutAcceptance))) ??
            [];

        this.errorTracking.trackErrors(betslipErrors, betslip.slips);

        return betslipErrors;
    }
}
